import { I as t } from "../../iconLoader.gen-zD5QAuAl.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
